import React, { Component } from "react";
import "./style.css";
class IntelligentContent extends Component {
  render() {
    const { item, handleInlineVisibleMajor } = this.props;
    return (
      <div className="intelligentDataColumn_box">
        <div className="intelligentDataColumn_school_box">
          <div style={{ height: 35, width: 10 }} className="fl"></div>
          <div className="fl">{item.school_code}</div>
          <div className="fl major_left_15">{item.school_name}</div>
          <div className="clear"></div>
        </div>
        <table
          style={{ position: "unset", fontWeight: "normal" }}
          className="intelligentDataHead_table_box"
        >
          <tbody>
            <tr>
              <td
                style={{
                  borderLeft: 0,
                  borderBottom: 0,
                  width: "42%",
                  textAlign: "left",
                  paddingLeft: 5,
                }}
              >
                院校代码、院校（专业）名
              </td>
              <td style={{ width: "10%", borderBottom: 0 }}>计划人数</td>
              <td style={{ width: "5%", borderBottom: 0 }}>学制</td>
              <td style={{ width: "10%", borderBottom: 0 }}>培养层次</td>
              <td style={{ width: "10%", borderBottom: 0 }}>最低分</td>
              <td style={{ borderRight: 0, width: "23%", borderBottom: 0 }}>
                位次号
              </td>
            </tr>
          </tbody>
        </table>
        <table className="intelligentDataColumn_major_table_box">
          <tbody>
            {item.intelligent_school_majors.map((major, index) => {
              return (
                <tr key={index}>
                  <td
                    style={{
                      borderLeft: 0,
                      width: "42%",
                      textAlign: "left",
                      paddingLeft: 5,
                    }}
                  >
                    {major.major_name}
                  </td>
                  <td style={{ width: "10%" }}>{major.plan_num}</td>
                  <td style={{ width: "5%" }}>{major.school_year}</td>
                  <td style={{ width: "10%" }}>{major.level}</td>
                  <td style={{ width: "10%" }}>{major.score}</td>
                  <td
                    onClick={() =>
                      handleInlineVisibleMajor(major.major_hash_id)
                    }
                    style={{ borderRight: 0, width: "23%" }}
                  >
                    {major.rank}
                    <img
                      className="fr"
                      alt=""
                      src={require("../../../../../../../images/intelligent/detail.png")}
                    ></img>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default IntelligentContent;



// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataHome/components/IntelligentAllMajorModal/components/IntelligentContent/index.js